import type { ComponentProps } from "./organizations.d";
import "./organizations.scss";

import React, { useState } from "react";

import { useAppStore } from "../../../react4xp/shared/stores";

function Component(props: ComponentProps) {
	const { nationality, nationalItems, internationality, internationalItems } = props;
	const visibleItemsCount = 10;

	const appStore = useAppStore((state) => state);

	const [showMoreNational, setShowMoreNational] = useState(false);
	const [showMoreInternational, setShowMoreInternational] = useState(false);

	const renderOrganizationsSection = (
		title: string,
		items: ComponentProps["nationalItems"]["hits"],
		showMore: boolean,
		setShowMore: (value: boolean) => void
	) => {
		if (!items || items.length === 0) return null;

		return (
			<div className="organizations-section">
				{title && <h3 className="section-title">{title}</h3>}
				<div className="organizations-grid">
					{items.map(
						({ _id, displayName, data: { contentTypeImage, contentTypeImageAltText, link, description } }, j) => (
							<div key={_id} className={`organization-item ${!showMore && j + 1 > visibleItemsCount ? "d-none" : ""}`}>
								<a href={link} className="organization-link" target="_blank" rel="noopener noreferrer">
									{contentTypeImage && (
										<img
											src={contentTypeImage}
											alt={contentTypeImageAltText || displayName}
											loading="lazy"
											className="organization-logo"
										/>
									)}
									<p>{description}</p>
								</a>
							</div>
						)
					)}
				</div>

				{/* Кнопка показать больше */}
				{items.length > visibleItemsCount && (
					<div className="text-center mt-4">
						<button type="button" className="btn btn-primary" onClick={() => setShowMore(!showMore)}>
							{showMore ? appStore.phrases?.["hide"] : appStore.phrases?.["showAll"]}
							<i className={`fa-solid fa-chevron-${!showMore ? "down" : "up"}`}></i>
						</button>
					</div>
				)}
			</div>
		);
	};

	return (
		<section className="organizations">
			<div className="container-fluid">
				<img src={appStore.imageLinks?.decor} alt="decor img" className="decor" />

				<div className="organizations-section-wrapper">
					{/* National Organizations */}
					{renderOrganizationsSection(nationality, nationalItems.hits, showMoreNational, setShowMoreNational)}

					{/* International Organizations */}
					{renderOrganizationsSection(
						internationality,
						internationalItems.hits,
						showMoreInternational,
						setShowMoreInternational
					)}
				</div>

				{/* Empty state */}
				{(!nationalItems.hits || nationalItems.hits.length === 0) &&
					(!internationalItems.hits || internationalItems.hits.length === 0) && (
						<div className="empty">
							<h3>{appStore.phrases?.["empty"]}</h3>
						</div>
					)}
			</div>
		</section>
	);
}

export default function WrappedComponent(props: ComponentProps) {
	return <Component {...props} />;
}
